import { Download } from "lucide-react";
import { toast } from "sonner";
import { PRESS_ITEMS } from "@/lib/site";
import { Reveal, SectionHead } from "./shared";
import { scrollToId } from "@/lib/lenis";

export default function PressKit() {
  const notify = () =>
    toast.info("Il materiale stampa sarà disponibile a ottobre 2026. Nel frattempo, scrivici dal modulo contatti.");

  return (
    <section id="press" className="relative bg-lake-deep py-20 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHead
          kicker="Press Kit"
          title="Il booktrailer verticale"
          sub="Il romanzo in 30 secondi, pronto per TikTok, Reels e YouTube Shorts. Per gli altri materiali stampa scriveteci dal modulo dedicato."
        />

        <div className="mt-14 flex justify-center">
          {PRESS_ITEMS.map((item, i) => (
            <Reveal key={item.id} delay={i * 0.08} className="w-full max-w-md">
              {item.url ? (
                <a
                  data-testid={item.testid}
                  href={item.url}
                  download
                  className="group flex h-full w-full flex-col rounded-xl border border-gold/50 bg-lake-teal/40 p-6 text-left shadow-[0_0_25px_rgba(197,155,39,0.12)] transition-colors duration-300 hover:border-gold-shimmer hover:bg-lake-teal/60"
                >
                  <div className="flex items-center justify-between">
                    <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gold">
                      <Download className="h-4 w-4 text-ink-dark" />
                    </div>
                    <span className="rounded-full bg-gold px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.15em] text-ink-dark">
                      Scarica
                    </span>
                  </div>
                  <h3 className="mt-5 text-sm font-semibold leading-snug text-parchment-ivory">{item.title}</h3>
                  <p className="mt-1 text-xs text-parchment-ivory/50">{item.format}</p>
                </a>
              ) : (
                <button
                  data-testid={item.testid}
                  onClick={notify}
                  className="group flex h-full w-full flex-col rounded-xl border border-parchment-ivory/15 bg-lake-teal/30 p-6 text-left transition-colors duration-300 hover:border-gold-shimmer/60 hover:bg-lake-teal/50"
                >
                  <div className="flex items-center justify-between">
                    <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gold/15">
                      <Download className="h-4 w-4 text-gold-shimmer" />
                    </div>
                    <span className="rounded-full border border-gold/40 px-2 py-0.5 text-[10px] uppercase tracking-[0.15em] text-gold-shimmer">
                      In arrivo
                    </span>
                  </div>
                  <h3 className="mt-5 text-sm font-semibold leading-snug text-parchment-ivory">{item.title}</h3>
                  <p className="mt-1 text-xs text-parchment-ivory/50">{item.format}</p>
                </button>
              )}
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.3}>
          <p className="mt-10 text-sm text-parchment-ivory/55">
            Redazioni, bookstagrammer e booktoker: per ricevere i materiali in anteprima o una
            copia ARC digitale,{" "}
            <button
              data-testid="press-contact-link"
              onClick={() => scrollToId("contatti")}
              className="font-semibold text-gold-shimmer underline decoration-gold/50 underline-offset-4 transition-colors hover:text-gold"
            >
              scriveteci dal modulo dedicato
            </button>
            .
          </p>
        </Reveal>
      </div>
    </section>
  );
}
